import { Layout, Row, Col, Image, Card } from "antd";
import LoginBanner from "@assets/SVG/rightImg.jpg";

import styles from "./Layout.module.scss";
import { imageKey, mediaHost } from "~/Utils";
import mahbLogo from "@assets/SVG/mahb-logo.svg"

export const OnBoarding = (props: any) => {
  return (
    <Layout.Content>
      <Row
        className={styles.leftSideOverallaySection}
        // style={{ height: window.innerHeight }}
        align="middle"
      >
        {/* <Col
          // style={{ paddingTop: "30px", paddingBottom: "30px" }}
          xs={{ span: 0 }}
          md={14}
        >
          <Col
            style={{ width: "100%", height: "600px" }}
            className={styles.rightSideSection}
          ></Col>
        </Col> */}
        <Col
          xs={{ span: 0 }}
          md={15}
        >
          <Col
          // style={{ width: "100%", height: "600px" }}
          // className={styles.rightSideSection}
          >
            <div>
              <img
                src={LoginBanner}
                // preview={false}
                // style={{maxHeight : "90%"}}
                style={{height : 680, width : "100%"}}
              />
            </div>
          </Col>
        </Col>
        <Col
          xs={{ span: 24 }}
          md={9}
        >
          <div className={styles.onboardingContentWrapper}>
            <Row
              justify="center"
              style={{ width: "100%", marginBottom: styles.whitespace3, marginTop: styles.whitespace3 }}
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 16 }}
              >
                <Row
                  gutter={8}
                  justify="center"
                  align="middle"
                >
                  <Image
                    style={{ maxWidth: 150 }}
                    src={mahbLogo}
                    preview={false}
                  />
                </Row>
              </Col>
            </Row>
            <Row
              justify="center"
              align="middle"
              style={{ marginTop: styles.whitespace3, width: "100%" }}
            >
              <Col
                style={{ 
                  // height: "450px"
                 }}
                xs={{ span: 24 }}
                md={{ span: 18 }}
              >
                <Card
                  className={styles.cardStyle}
                  hoverable
                  bodyStyle={{
                    width: "100%",
                    margin: "auto 24px",
                    height: "520px",
                    paddingBlock: styles.whitespace4,
                    display : "flex",
                    alignItems : "center"
                  }}
                >
                  {props.children}
                </Card>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Layout.Content>
  );
};
